// AD-2471: a person added to a form one by one, as loaded from the form's saved recipients. 'excluded' is the
// 'Leave ... out' tick, so reopening the form shows it as the school left it and the next save keeps it.
export const individualRecipient = (assignment, id = assignment.personId) => ({
    id,
    assignmentId: assignment.id,
    label: assignment.displayName,
    excluded: !!assignment.excluded
});
